import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=d57df962"
import script from "./EditProducts.vue?vue&type=script&lang=js"
export * from "./EditProducts.vue?vue&type=script&lang=js"
import style0 from "./EditProducts.vue?vue&type=style&index=0&id=d57df962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports